import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import core from '@/com/mixins/core.mixin'

import axios from 'axios'

// Setup axios interceptor to handle 401/403 errors (expired/invalid tokens)
// This must be done here to avoid circular dependencies
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Token is expired, invalid, or forbidden - logout via store and redirect to home
      store.dispatch('stateUser/logout')
      router.push({ name: 'home' })
    }
    return Promise.reject(error)
  }
)

createApp(App)
  .mixin({mixins: [core] })
  .use(store)
  .use(router).mount('#app')
